import React from 'react';
import { Check, ArrowLeft } from 'lucide-react';
import { useCMS } from '../store/cmsStore';

export default function Packages() {
  const { data } = useCMS();
  const packages = data.packages.filter(pkg => pkg.active).sort((a, b) => a.order - b.order);

  return (
    <section id="packages" className="py-12 md:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block bg-brown-100 text-brown-700 px-4 py-2 rounded-full text-sm font-cairo font-medium mb-4">
            باقاتنا
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-amiri font-bold text-gray-900 mb-4">
            اختر الرحلة التي تناسبك
          </h2>
          <p className="text-gray-600 font-cairo max-w-2xl mx-auto text-sm md:text-base">
            باقات مدروسة بعناية تجمع بين الراحة والسعر المناسب — جميعها تشمل النقل ذهاباً وعودة والسكن الفندقي.
          </p>
        </div>

        {/* Packages Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {packages.map((pkg, index) => (
            <div
              key={pkg.id}
              className={`relative bg-white rounded-2xl shadow-lg border-2 overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1 ${
                pkg.popular ? 'border-gold-400 shadow-gold-100' : 'border-gray-100'
              }`}
            >
              {/* Badge */}
              {pkg.popular && (
                <div className="absolute top-0 left-0 right-0 bg-gold-500 text-white text-center py-2 text-sm font-cairo font-bold">
                  {pkg.badge}
                </div>
              )}

              {/* Content */}
              <div className={`p-6 md:p-8 ${pkg.popular ? 'pt-12' : ''}`}>
                {/* Title */}
                <h3 className="text-xl md:text-2xl font-amiri font-bold text-gray-900 mb-2">
                  {pkg.name}
                </h3>
                
                {/* Badge (for non-popular) */}
                {!pkg.popular && (
                  <span className="inline-block bg-brown-100 text-brown-700 px-3 py-1 rounded-full text-xs font-cairo mb-4">
                    {pkg.badge}
                  </span>
                )}

                {/* Description */}
                <p className="text-gray-600 font-cairo text-sm md:text-base mb-6">
                  {pkg.description}
                </p>

                {/* Features */}
                <ul className="space-y-3 mb-8">
                  {pkg.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start gap-3">
                      <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 font-cairo text-sm md:text-base">{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <a
                  href={pkg.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`block w-full text-center py-3 rounded-xl font-cairo font-bold text-base md:text-lg transition-all ${
                    pkg.popular
                      ? 'bg-gold-500 text-white hover:bg-gold-600 shadow-lg'
                      : 'bg-brown-600 text-white hover:bg-brown-700'
                  }`}
                >
                  <span className="flex items-center justify-center gap-2">
                    احجز الآن
                    <ArrowLeft className="w-5 h-5" />
                  </span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}